<template>
    <div>
         <div class="page-title">Edit Template</div>
         <div class="page-box">
            <templateFrom ref="ruleForm" :form="form"></templateFrom>
            <div class="page-btn">
                <el-button type="warning" @click="onSubmit">Submit</el-button>
                <el-button @click="onBack">Cancel</el-button>
            </div>
         </div>
    </div>
</template>

<script>
    import {editTemplates,getTemplatesDetail} from '@/api/admin/notification'
    import templateFrom from './components/templateFrom'
    export default {
        components:{templateFrom},
         props:{
            id:{
                type:Number,
                default:0
            }
        },
        data() {
            return {
                form: {
                    type: 3, 
                    statusTemplateType: 0, 
                    formType: 0, 
                    title: null, 
                    email: {
                        subject: null, 
                        body: null
                    }, 
                    announcement: {
                        subject: null, 
                        body: null
                    }
                }
            }
        },
        created(){
            this.getTemplatesDetail()
        },
        methods:{
            onSubmit(){
                this.$refs.ruleForm.$refs.ruleForm.validate((valid) => {
                if (valid) {
                   this.editTemplates()
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            getTemplatesDetail(){
               getTemplatesDetail(this.id).then((v)=>{
                  this.form = v.data
               })
            },
            editTemplates(){
                editTemplates(this.id,this.form).then(()=>{
                     this.$router.push({path:`/admin/templateDetail/${this.id}`})
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.page-box{
    background-color: #fff;
    padding: 20px;
}
.page-btn{
    text-align: right;
}
</style>